import React from 'react';
import {
    PanelHeader,
    Div,
    SplitCol,
    SplitLayout,
    Button, ButtonGroup, NativeSelect, FormItem, SimpleCell, Switch, Chip
} from '@vkontakte/vkui';


import {AdaptivityContext, CODE_SALE_POINT_MONITORING_STATUS_NEW, EMPTY_INN, setQuizStep} from "../assets/constants";

import BaseComponent from "../components/BaseComponent";
import withOffline from "../components/withOffline";

import * as constants from "../assets/constants";

import moment from "moment/moment";
import SalePointMonitoringDocsApi from "../api/SalePointMonitoringDocs";
import SelectObject from "../assets/SelectObject";
import SalePointSelectObject from "./salePointSelectObject";
import {Icon20Clear, Icon24DocumentPlusOutline} from "@vkontakte/icons";
import MallSelectObject from "../references/Klients/mallSelectObject";
import KlientsSelectObject from "../references/Klients/klientsSelectObject";
import HelpButton from "../assets/HelpButton";


class SalePointMonitoringStep1Old extends BaseComponent {

    state = {
        loading: true,


        statusLabels: {},
        error_klient: '',
        error_address: '',
        error_comment: '',
    }

    constructor(props) {
        super(props);
        this.state.statusLabels = constants.getSalePointMonitoringStatuses()
        delete this.state.statusLabels['']
    }


    receiveMessage = (event) => {
        if (event.data.type == "newSalePointCreated") {

            this.setSalePoint(event.data.value)

            this.setMall(event.data.value.mall)

            this.setKlient(event.data.value.klient)
        }
    }
    changeCurrentStatus = async (status) => {
        const {item} = this.props
        if (status == constants.CODE_FACING_MONITORING_STATUS_END && item.doc_data.status != constants.CODE_SALE_POINT_MONITORING_STATUS_IN_PROCESS) {
            window.postMessage({
                type: 'error',
                text: 'Статус "Завершен" можно будет установить только после статуса "В работе"'
            })
            return
        }
        item.doc_data.status = status


        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setStatus({doc_id: item.doc_data.id, status})
        }
        window.postMessage({type: 'setCurrentSalePointMonitoring', value: item})

    }


    setKlient = async (klient) => {
        if (!klient.uid) return

        const {item} = this.props

        window.postMessage('resetDefaultSelected')
        item.doc_data.klient = klient
        item.doc_data.sale_point = {}
        item.doc_data.mall_id = null
        item.doc_data.mall = {}
        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setKlient({doc_id: item.doc_data.id, klient_id: klient.uid})
        }
        setTimeout(() => window.postMessage({type: 'setCurrentSalePointMonitoring', value: item}), 700)
    }

    setMall = async (mall) => {
        if (!mall || !mall.uid) {
            return
        }
        const {item} = this.props
        window.postMessage('resetDefaultSelected')
        item.doc_data.mall_id = mall.uid
        item.doc_data.mall = mall
        item.doc_data.klient = {}
        item.doc_data.sale_point = {}

        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setMall({doc_id: item.doc_data.id, mall_id: mall.uid})
        }
        setTimeout(() => window.postMessage({type: 'setCurrentSalePointMonitoring', value: item}), 700)
    }

    setSalePoint = async (sale_point) => {
        if (!sale_point.uid) return

        const {item} = this.props
        const oldKlient = item.doc_data.klient
        window.postMessage('resetDefaultSelected')
        setTimeout(async () => {
            item.doc_data.sale_point = sale_point
            item.doc_data.klient = sale_point.klient
            item.doc_data.mall = sale_point.mall

            if (item.doc_data.id > 0) {
                await SalePointMonitoringDocsApi.setSalePoint({doc_id: item.doc_data.id, sale_point_id: sale_point.uid})
                if (oldKlient && oldKlient.uid != sale_point.klient.uid) {
                    await SalePointMonitoringDocsApi.setKlient({
                        doc_id: item.doc_data.id,
                        klient_id: sale_point.klient.uid
                    })
                }
            }
            window.postMessage({type: 'setCurrentSalePointMonitoring', value: item})
        }, 500)
    }


    clearKlient = async () => {
        this.setActiveModal(null)
        const {item} = this.props

        window.postMessage('resetDefaultSelected')
        item.doc_data.klient = {}
        item.doc_data.sale_point = {}

        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setKlient({doc_id: item.doc_data.id, klient_id: null})
        }
        setTimeout(() => window.postMessage({type: 'setCurrentSalePointMonitoring', value: item}), 700)
    }

    clearMall = async () => {

        const {item} = this.props
        window.postMessage('resetDefaultSelected')
        item.doc_data.mall_id = null
        item.doc_data.mall = {}
        setTimeout(() => window.postMessage({type: 'setCurrentSalePointMonitoring', value: item}), 700)
        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setMall({doc_id: item.doc_data.id, mall_id: null})
        }

    }
    clearSalePoint = async () => {

        const {item} = this.props
        window.postMessage('resetDefaultSelected')
        item.doc_data.sale_point = {}
        setTimeout(() => window.postMessage({type: 'setCurrentSalePointMonitoring', value: item}), 700)
        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setMall({doc_id: item.doc_data.id, sale_point_id: null})
        }

    }

    setUseMall = async (e) => {
        const {item} = this.props
        item.doc_data.useMall = e.currentTarget.checked ? 1 : 0
        if (item.doc_data.useMall) {
            await this.clearKlient()
        } else {
            await this.clearMall()
        }

        if (item.doc_data.id > 0) {
            await SalePointMonitoringDocsApi.setUseMall({doc_id: item.doc_data.id, useMall: item.doc_data.useMall ?? 0})
        }

        setTimeout(() => window.postMessage({type: 'setCurrentSalePointMonitoring', value: item}), 700)
    }

    sp_types = constants.getSalePointsTypes()

    render() {

        if (!this.props.item) return

        const {item} = this.props


        const current_user_id = this.props.current_user ? this.props.current_user.id : null

        return (
            <div>
                <SplitLayout>
                    <SplitCol>
                        <PanelHeader fixed={true}>
                            Мониторинг торговой точки. Шаг 1
                        </PanelHeader>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        {this.props.isOffline && <Chip style={{float: 'right'}} removable={false} className="all-docs"
                                                       id="is_offline">Offline режим<HelpButton
                            text={"Нет связи с интернет. Работаем в автономном режиме"}/></Chip>}
                        <FormItem top={"Статус"}>
                            <NativeSelect key={'status-sp-monitoring-doc-step1'}
                                          style={{
                                              zIndex: 6,
                                              marginLeft: '10px',
                                              height: '30px',
                                              maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                          }}
                                          disabled={!item
                                              || item.doc_data.status == constants.CODE_SALE_POINT_MONITORING_STATUS_END
                                              || (item && item.doc_data && item.doc_data.user_id != current_user_id)
                                          }
                                          value={item.doc_data.status}
                                          onChange={(e) => this.changeCurrentStatus(e.target.value)}
                            >
                                {Object.keys(this.state.statusLabels).map((itemP, indexP) => (
                                    <option value={itemP}>{this.state.statusLabels[itemP]}</option>
                                ))}</NativeSelect>
                        </FormItem>
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <SimpleCell Component="label" multiline style={{maxWidth: '250px'}}

                                    after={<Switch size={10} checked={item.doc_data.useMall == 1}
                                                   onChange={this.setUseMall}/>}>
                            Выбор точки по ТЦ
                        </SimpleCell>
                    </SplitCol>
                </SplitLayout>


                <SplitLayout>
                    <SplitCol>
                        <KlientsSelectObject current_user={this.props.current_user}
                                             title="Клиент" app="klients"
                                             disabled={item.doc_data.useMall}

                                             act="getKlientsjson"
                                             className={'selectObjectDropdownStyle'}
                                             style={{minHeight: '33px'}}
                                             error={this.state.error_klient}
                                             modal_title="Клиенты"
                                             base_url={this.props.base_url}
                                             selectObject={this.setKlient}
                                             default={item.doc_data.klient}
                                             params={`show_all=1&no_empty_inn=1`}
                                             mode="outline"
                                             size="s"
                                             create_action
                                             addon={
                                                 <Button onClick={() => this.clearKlient()} mode="outline" size="s"


                                                         className="btn-toolbar-sclads"
                                                         before={<Icon20Clear/>}></Button>
                                             }
                        />
                        <Div>
                            <h5 className="vkuiTypography vkuiTypography--normalize vkuiFormItem__top vkuiSubhead ">Если
                                клиента найти и выбрать не получается, следует выбрать торговый центр и найти торговую
                                точку</h5>
                        </Div>
                    </SplitCol>
                </SplitLayout>
                {item.doc_data.useMall == 1 && <SplitLayout>
                    <SplitCol>
                        <MallSelectObject
                            className={'selectObjectDropdownStyle'}
                            current_user={this.props.current_user}
                            title={`Торговый комплекс`}
                            style={{minHeight: '33px'}}
                            app="salePoints"
                            act="getList"
                            params={`isMalls=1`}
                            default={item.doc_data.mall}
                            modal_title="Список торговых объектов"
                            mode="outline"
                            size="s"
                            selectObject={this.setMall}
                            create_action
                            current_doc={item}
                            addon={
                                <Button onClick={() => this.clearMall()} mode="outline" size="s"

                                        className="btn-toolbar-sclads" before={<Icon20Clear/>}></Button>
                            }
                        />
                    </SplitCol>
                </SplitLayout>}
                <SplitLayout>
                    <SplitCol>
                        <SalePointSelectObject current_user={this.props.current_user}
                                               title="Торговая точка" app="salepoints"
                                               act="getList"
                                               className={'selectObjectDropdownStyle'}
                                               style={{minHeight: '33px'}}
                                               error={this.state.error_address}
                                               modal_title={`Торговые точки ${item.doc_data.klient && item.doc_data.klient.uid ? item.doc_data.klient.title : ''} ${item.doc_data.useMall == 1 && item.doc_data.mall && item.doc_data.mall.uid ? 'ТЦ ' + item.doc_data.mall.title : ''}`}
                                               base_url={this.props.base_url}
                                               selectObject={this.setSalePoint}
                                               disabled={!item.doc_data.klient && !item.doc_data.mall}
                                               default={item.doc_data.sale_point}
                                               params={`klient_id=${item.doc_data.klient && item.doc_data.klient.uid ? item.doc_data.klient.uid : ''}&mall_id=${item.doc_data.useMall == 1 && item.doc_data.mall && item.doc_data.mall.uid ? item.doc_data.mall.uid : ''}`}
                                               mode="outline"
                                               size="s"
                                               create_action
                                               current_doc={item}
                                               addon={
                                                   <Button onClick={() => this.clearSalePoint()} mode="outline" size="s"

                                                           className="btn-toolbar-sclads"
                                                           before={<Icon20Clear/>}></Button>
                                               }
                        />
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Номер: {item ? item.doc_data.nomer : 'Новый'}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Дата: {item ? item.doc_data.date : moment(new Date()).format('DD.MM.YYYY')}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                {item && item.doc_data.comment && <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Комментарий: {item ? item.doc_data.comment : ''}
                        </Div>
                    </SplitCol>
                </SplitLayout>}
                <SplitLayout>
                    <SplitCol>
                        <Div className="action-board">
                            <ButtonGroup mode="horizontal" stretched>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => window.postMessage({type: 'goToSalePointMonitoringDocs'})}>Назад</Button>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => this.nextStep()}>Далее</Button>
                            </ButtonGroup>
                        </Div>
                    </SplitCol>
                </SplitLayout>
            </div>
        )
    }


    nextStep = () => {

        let error = 0

        const {item} = this.props

        this.setState({error_klient: '', error_address: ''})

        if (!item.doc_data.klient) {
            error++
            this.setState({error_klient: "Необходимо указаать клиента!"})
        }

        if (!(item.doc_data && item.doc_data.sale_point && item.doc_data.sale_point.uid)) {
            error++
            this.setState({error_address: "Необходимо указаать торговую точку!"})
        }

        if (error > 0) return


        const images_url = this.props.images_url


        let images = {}

        const document_ = {
            date: new Date(),
            comment: '',
            klient_id: item.doc_data.klient.uid,
            useMall: item.doc_data.useMall ?? 0,
            sale_point_id: item.doc_data.sale_point.uid,
            mall_id: item.doc_data.mall ? item.doc_data.mall.uid : null,
            status: constants.CODE_SALE_POINT_MONITORING_STATUS_DRAFT,
            items: [],
            images
        }

        if (!(item.doc_data && item.doc_data.id > 0)) {
            SalePointMonitoringDocsApi.save(document_,
            ).then(async (response) => {
                const {data} = response

                if (data.doc_id) {
                    const doc = await SalePointMonitoringDocsApi.getOne(data.doc_id)

                    if (doc) {
                        window.postMessage({type: 'setCurrentSalePointMonitoring', value: doc.data})
                        setTimeout(() => setQuizStep(2, 'SalePointMonitoring'), 500)
                    }
                }
            })
        } else {

            setQuizStep(2, 'SalePointMonitoring')
        }

    }

}

export default withOffline(SalePointMonitoringStep1Old)